import React from 'react';
import Wysiwyg from 'components/blocks/wysiwyg/Wysiwyg';
import camelCase from 'lodash/camelCase';

interface StatsProps {
  stats: {
    title: string;
    subTitle: string;
  }[];
}

function Stats({ stats = [] }: StatsProps): React.ReactNode {
  if (!stats.length) {
    return null;
  }
  return (
    <ul className="stats">
      {stats.map((stat) => (
        <li className="stats__item" key={`${camelCase(stat.title)}_stat`}>
          <div className="stats__title">
            <Wysiwyg content={stat.title} />
          </div>
          <div className="stats__subTitle">
            <Wysiwyg content={stat.subTitle} />
          </div>
        </li>
      ))}
    </ul>
  );
}

export default Stats;
